import { Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import CommonTextField from "../../../common/components/functional/commonTextField/CommonTextField";

const BasicInfo = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();

  return (
    <FormSection>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("customers:costCenters:costCenterName")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          name="name"
          control={control}
          rules={{ required: { value: true, message: "" } }}
          render={({ field }) => (
            <CommonTextField {...field} fullWidth error={!!errors.name} />
          )}
        />
      </Grid>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("customers:costCenters:code")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          name="code"
          control={control}
          render={({ field }) => (
            <CommonTextField {...field} fullWidth error={!!errors.code} />
          )}
        />
      </Grid>
    </FormSection>
  );
};

export default BasicInfo;
